import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import {
	Row,
	Card,
	CardBody,
	FormGroup,
	Label,
	Input,
	Button,
} from 'reactstrap';
import Select from 'react-select';
import BreadcrumbContainer from 'Components/BreadcrumbContainer';
import { Colxx, Separator } from 'Components/CustomBootstrap';
import { NotificationManager } from 'Components/ReactNotifications';
import LoadingOverlay from 'Components/LoadingOverlay';
import CustomSelectInput from 'Components/CustomSelectInput';
import IntlMessages from 'Util/IntlMessages';
import {
	couponCategoriesCreate,
	couponCategoriesGetDetails,
	couponCategoriesUpdate,
	couponCategoriesGetOptions,
	errorReset,
} from 'Redux/actions';
import * as couponCategoriesReducer from 'Redux/couponCategories/reducer';

class PageCouponCategory extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			category: '',
			description: '',
			shops: [],
			no_effect_type: 'M',
			pay_code: 'CP',
		};
		this.getCategoryCode = this.getCategoryCode.bind(this);
		this.getBreadcrumb = this.getBreadcrumb.bind(this);
		this.onChangeHandler = this.onChangeHandler.bind(this);
		this.onSubmitHandler = this.onSubmitHandler.bind(this);
		this.onAddShop = this.onAddShop.bind(this);
		this.onRemoveShop = this.onRemoveShop.bind(this);
		this.onChangeShopHandler = this.onChangeShopHandler.bind(this);
	}

	getCategoryCode(props = this.props) {
		return props.match.params.categoryId ? decodeURIComponent(props.match.params.categoryId) : null;
	}

	getBreadcrumb(props = this.props) {
		const categoryCode = this.getCategoryCode(props);
		return [
			{ id: 'menu.coupon', href: '/coupon-category/list' },
			{ id: 'couponCategory.heading', href: categoryCode ? `/coupon-category/edit/${encodeURIComponent(categoryCode)}` : '/coupon-category/create' },
		];
	}

	componentDidMount() {
		const categoryCode = this.getCategoryCode();
		if (categoryCode) {
			this.props.couponCategoriesGetDetails(categoryCode);
		}
		this.props.errorReset('couponCategory');
		this.props.couponCategoriesGetOptions();
	}

	componentDidUpdate(prevProps) {
		const categoryCode = this.getCategoryCode();
		const prevCategoryCode = this.getCategoryCode(prevProps);

		if (categoryCode) {
			const prevCategory = prevProps.couponCategory.get(prevCategoryCode);
			const category = this.props.couponCategory.get(categoryCode);
			if ((prevCategoryCode !== categoryCode || (category && category !== prevCategory)) && category) {
				this.setState({
					category: category.category || '',
					description: category.description || '',
					shops: (category.shops || []).map((shop) => ({
						sh_code: shop.sh_code || '',
						sh_name: shop.sh_name || '',
					})),
					no_effect_type: category.no_effect_type || 'M',
					pay_code: category.pay_code || null,
				});
			}
		}

		const prevStatus = prevProps.status.get('couponCategory');
		const status = this.props.status.get('couponCategory');

		if (status && prevStatus !== status) {
			switch (status) {
			case 'created':
				NotificationManager.success('The coupon category is created successfully.', 'Category Created');
				if (this.props.current) {
					this.props.history.push(`/app/coupon-category/edit/${encodeURIComponent(this.props.current)}`);
				}
				break;
			case 'submitted':
				NotificationManager.success('The coupon category is updated successfully.', 'Category Updated');
				if (categoryCode) {
					this.props.couponCategoriesGetDetails(categoryCode);
				}
				break;
			case 'has-errors':
				NotificationManager.error('An error occurred. The operation failed.', 'Operation Failed');
				break;
			default:
				break;
			}
		}
	}

	onChangeHandler(field, value) {
		this.setState({ [field]: value });
	}

	onAddShop() {
		this.setState((prevState) => ({
			shops: [...prevState.shops, { sh_code: '', sh_name: '' }],
		}));
	}

	onRemoveShop(index) {
		this.setState((prevState) => ({
			shops: prevState.shops.filter((_, i) => i !== index),
		}));
	}

	onChangeShopHandler(index, field, value) {
		this.setState((prevState) => {
			const shops = [...prevState.shops];
			if (field === 'sh_code') {
				const option = this.warehouseOptions.find((opt) => opt.value === value);
				shops[index] = {
					sh_code: value,
					sh_name: option ? option.label : '',
				};
			} else {
				shops[index] = { ...shops[index], [field]: value };
			}
			return { shops };
		});
	}

	onSubmitHandler(e) {
		e && e.preventDefault();
		const categoryCode = this.getCategoryCode();
		const {
			category,
			description,
			shops,
			no_effect_type,
			pay_code,
		} = this.state;

		const isCreate = !categoryCode;

		const payload = {
			category: category.trim(),
			description: description || null,
			shops: shops
				.filter((shop) => shop.sh_code.trim() !== '')
				.map((shop) => ({
					sh_code: shop.sh_code.trim(),
					sh_name: shop.sh_name ? shop.sh_name.trim() : null,
				})),
			no_effect_type: no_effect_type || null,
			pay_code: pay_code || null,
		};

		if (isCreate) {
			this.props.couponCategoriesCreate(payload);
		} else {
			this.props.couponCategoriesUpdate(payload);
		}
	}

	render() {
		const categoryCode = this.getCategoryCode();
		const isCreate = !categoryCode;
		const { status } = this.props;
		const categoryStatus = status.get('couponCategory');
		const isLoading = categoryStatus === 'fetching';
		const isSubmitting = categoryStatus === 'creating' || categoryStatus === 'submitting';

		const {
			category,
			description,
			shops,
			no_effect_type,
			pay_code,
		} = this.state;

		const couponCatOptions = this.props.couponCatOptions;
		const warehouseOptions = couponCatOptions.get('wh_codes')
			? (couponCatOptions.get('wh_codes').toJS ? couponCatOptions.get('wh_codes').toJS() : couponCatOptions.get('wh_codes'))
			: [];
		this.warehouseOptions = warehouseOptions;

		const payCodeOptions = couponCatOptions.get('pay_codes')
			? (couponCatOptions.get('pay_codes').toJS ? couponCatOptions.get('pay_codes').toJS() : couponCatOptions.get('pay_codes'))
			: [];

		const noEffectTypeOptions = [
			{ value: 'M', label: 'M' },
			{ value: 'D', label: 'D' },
		];

		return (
			<Fragment>
				<LoadingOverlay active={isLoading} />
				<Row>
					<Colxx xxs="12">
						<div className="float-left">
							<BreadcrumbContainer
								heading={<IntlMessages id="couponCategory.heading" />}
								items={this.getBreadcrumb()}
								match={this.props.match}
							/>
						</div>
						<div className="clearfix"></div>
					</Colxx>
				</Row>

				<Separator className="mb-5" />

				<Row>
					<Colxx xxs="12">
						<Card>
							<CardBody>
								<form onSubmit={this.onSubmitHandler}>
									<Row>
										<Colxx xxs="12" md="6">
											<FormGroup>
												<Label>Category Code</Label>
												{isCreate ? (
													<Input
														type="text"
														value={category}
														maxLength={25}
														onChange={(e) => this.onChangeHandler('category', e.target.value.toUpperCase())}
														placeholder="Enter category code"
													/>
												) : (
													<Input
														type="text"
														value={category}
														readOnly
														disabled
													/>
												)}
											</FormGroup>
										</Colxx>

										<Colxx xxs="12" md="6">
											<FormGroup>
												<Label>Description</Label>
												<Input
													type="text"
													value={description}
													onChange={(e) => this.onChangeHandler('description', e.target.value)}
													placeholder="Enter description"
												/>
											</FormGroup>
										</Colxx>
									</Row>

									<Row className="d-none">
										<Colxx xxs="12" md="6">
											<FormGroup>
												<Label>No Effect Type</Label>
												<Select
													components={{ Input: CustomSelectInput }}
													className="react-select"
													classNamePrefix="react-select"
													value={noEffectTypeOptions.find((opt) => opt.value === no_effect_type)}
													isClearable={false}
													onChange={(v) => this.onChangeHandler('no_effect_type', v ? v.value : 'M')}
													options={noEffectTypeOptions}
												/>
											</FormGroup>
										</Colxx>

										<Colxx xxs="12" md="6">
											<FormGroup>
												<Label>Payment Method</Label>
												<Select
													components={{ Input: CustomSelectInput }}
													className="react-select"
													classNamePrefix="react-select"
													value={payCodeOptions.find((opt) => opt.value === pay_code)}
													isClearable={true}
													onChange={(v) => this.onChangeHandler('pay_code', v ? v.value : null)}
													options={payCodeOptions}
													placeholder="Select payment method"
												/>
											</FormGroup>
										</Colxx>
									</Row>

									<Row>
										<Colxx xxs="12">
											<FormGroup>
												<div className="d-flex justify-content-between align-items-center mb-2">
													<Label className="mb-0">Shops</Label>
													<Button
														type="button"
														color="primary"
														size="sm"
														onClick={this.onAddShop}
														disabled={isSubmitting}
													>
														<i className="simple-icon-plus mr-1" />
														Add Shop
													</Button>
												</div>
												{shops.length > 0 ? (
													<table className="table table-bordered">
														<thead>
															<tr>
																<th style={{ width: '40%' }}>Shop Code</th>
																<th style={{ width: '40%' }}>Shop Name</th>
																<th style={{ width: '20%' }}>Action</th>
															</tr>
														</thead>
														<tbody>
															{shops.map((shop, index) => (
																<tr key={index}>
																	<td>
																		<Select
																			components={{ Input: CustomSelectInput }}
																			className="react-select"
																			classNamePrefix="react-select"
																			value={shop.sh_code ? { value: shop.sh_code, label: shop.sh_code } : null}
																			isClearable={true}
																			onChange={(v) => this.onChangeShopHandler(index, 'sh_code', v ? v.value : '')}
																			options={warehouseOptions}
																			placeholder="Select shop code"
																		/>
																	</td>
																	<td>
																		<Input
																			type="text"
																			value={shop.sh_name}
																			readOnly
																			disabled
																			placeholder="Auto-filled from shop code"
																		/>
																	</td>
																	<td className="text-center">
																		<Button
																			type="button"
																			color="danger"
																			size="sm"
																			onClick={() => this.onRemoveShop(index)}
																			disabled={isSubmitting}
																		>
																			<i className="simple-icon-trash" />
																		</Button>
																	</td>
																</tr>
															))}
														</tbody>
													</table>
												) : (
													<p className="text-muted">No shops added. Click &quot;Add Shop&quot; to add applicable shops.</p>
												)}
											</FormGroup>
										</Colxx>
									</Row>

									<div className="text-center mt-2">
										<Button
											type="submit"
											size="lg"
											color="primary"
											disabled={isSubmitting || !category.trim()}
										>
											{isSubmitting ? 'Saving...' : (isCreate ? 'Create' : 'Save')}
										</Button>
									</div>
								</form>
							</CardBody>
						</Card>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => {
	const couponCatState = couponCategoriesReducer.selector(state);
	return {
		...couponCatState,
		couponCatOptions: couponCatState.options,
	};
};

export default connect(
	mapStateToProps,
	{
		couponCategoriesCreate,
		couponCategoriesGetDetails,
		couponCategoriesUpdate,
		couponCategoriesGetOptions,
		errorReset,
	}
)(PageCouponCategory);
